import { CSSProperties } from "react";

interface SvgIconProps { 
    src: string;
    width: string;
    height:string;
    style?: CSSProperties;
};

const Svg = ({ src, width, height, style }: SvgIconProps) => {
  return (
    <>
      <img
        src={`/svg/${src}`}
        alt={src}
        width={width}
        height={height}
        style={style}
      />
    </>
  );
};

export default Svg;
